import React from 'react';
import { ShieldCheck, Heart, UserCheck, Clock } from 'lucide-react';
export function About() {
  const features = [{
    title: 'Compassionate Service',
    desc: 'Personalized care that respects your dignity and independence.',
    icon: Heart
  }, {
    title: 'Accessible Fleet',
    desc: 'State-of-the-art ramps and securement systems for maximum safety.',
    icon: ShieldCheck
  }, {
    title: 'Professional Drivers',
    desc: 'Carefully screened, background-checked, and highly trained.',
    icon: UserCheck
  }, {
    title: 'Punctuality Matters',
    desc: 'We prioritize clear communication and flexible, on-time scheduling.',
    icon: Clock
  }];
  return <section id="about" className="py-24 bg-slate-900 text-white overflow-hidden relative" data-id="element-18">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-blue-600/10 skew-x-12 transform translate-x-20" data-id="element-19" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-21">
          <div data-id="element-22">
            <h2 className="text-blue-400 font-bold tracking-wide uppercase text-sm mb-3" data-id="element-23">
              About AMO
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-24">
              Delivering Peace of Mind and Freedom of Movement
            </h3>
            <div className="space-y-4 text-slate-300 text-lg leading-relaxed mb-8" data-id="element-25">
              <p data-id="element-26">
                Founded with a deep commitment to accessibility and dignity, AMO
                provides non-emergency transportation solutions tailored to our
                clients’ needs.
              </p>
              <p data-id="element-27">
                Based in Charlotte, North Carolina, we specialize in safe,
                reliable, and compassionate door-to-door wheelchair
                transportation for individuals who use wheelchairs or have
                mobility challenges.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-28">
              {features.map(f => <div key={f.title} className="flex items-start space-x-4" data-id="element-29">
                  <div className="bg-blue-600/20 p-3 rounded-lg" data-id="element-30">
                    <f.icon className="w-6 h-6 text-blue-400" data-id="element-31" />
                  </div>
                  <div data-id="element-32">
                    <h4 className="font-bold text-white mb-1" data-id="element-33">{f.title}</h4>
                    <p className="text-sm text-slate-400" data-id="element-34">{f.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-35">
            <div className="grid grid-cols-2 gap-4" data-id="element-36">
              <div className="space-y-4" data-id="element-37">
                <img src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=600" alt="Professional service" className="rounded-2xl h-64 w-full object-cover" data-id="element-38" />
                <div className="bg-blue-600 p-8 rounded-2xl" data-id="element-39">
                  <p className="text-4xl font-bold mb-1" data-id="element-40">100%</p>
                  <p className="text-blue-100 font-medium" data-id="element-41">Safety Record</p>
                </div>
              </div>
              <div className="space-y-4 pt-8" data-id="element-42">
                <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700" data-id="element-43">
                  <p className="text-4xl font-bold mb-1" data-id="element-44">24/7</p>
                  <p className="text-slate-400 font-medium" data-id="element-45">Availability</p>
                </div>
                <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=600" alt="Medical transport" className="rounded-2xl h-64 w-full object-cover" data-id="element-46" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}